/* eslint-disable react/sort-comp */
/* eslint-disable keyword-spacing */
import { h, Component } from "preact";
import Select from "react-select";
import "react-select/dist/react-select.css";
import { Scrollbars } from "react-custom-scrollbars";
import PreLoader from "../preLoader";
import style from "./style";

export default class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: this.props.selectedValue || "",
      labelValue: this.props.selectedLabel || "",
      showSelect: false,
      dataList: this.props.options || [],
      filteredList: this.props.options || [],
      closeBtnActive: false,
      showSelectWidth: 0,
    };
  }

  componentWillMount() {
    if (
      this.props.selectedValue !== "" &&
      this.props.selectedValue !== undefined
    ) {
      this.setState({
        closeBtnActive: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.options !== nextProps.options) {
      this.setState({
        dataList: nextProps.options,
        filteredList: nextProps.options,
      });
    }
    if (nextProps.selectedValue !== this.props.selectedValue) {
      if (
        nextProps.selectedValue !== "" &&
        nextProps.selectedValue !== undefined
      ) {
        this.setState({
          closeBtnActive: true,
          labelValue: nextProps.selectedLabel,
        });
      }
    }
  }
  openSelect() {
    this.setState({ showSelect: true });
  }

  _generateOptions(options, key) {
    if (options && options.length) {
      return options;
    }
  }
  handleChange(newValue) {
    this.setState({
      closeBtnActive: true,
      labelValue: newValue.label,
      selectedValue: newValue.value,
      showSelect: false,
    });
    this.props.handleClick && this.props.handleClick(newValue);
  }
  componentDidMount() {
    this.setState({
      showSelectWidth:
        this.dropDownWrapper.offsetWidth === 0
          ? "100%"
          : this.dropDownWrapper.offsetWidth,
    });
    document.addEventListener("mousedown", (e) => this.handleClickOutside(e));
    document.addEventListener("touchstart", (e) => this.handleClickOutside(e));
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", (e) =>
      this.handleClickOutside(e)
    );
    document.removeEventListener("touchstart", (e) =>
      this.handleClickOutside(e)
    );
  }

  // ---------------------------------- preserve false for droplists in Search Page ----------------------------------->>>

  handleClickOutside = (e) => {
    if (this.state.showSelect && !this.filter.contains(e.target)) {
      this.setState({ showSelect: false });
    }
  };

  inputRenderer = (params) => {
    return (
      <div style={{ textAlign: "center" }}>
        <input class={style.searchBar} placeholder={"Search"} />
      </div>
    );
  };
  menuRenderer = (params) => {
    // use default renderer in a hacky way
    const menu = Select.defaultProps.menuRenderer(params);
    return (
      <div class={style.filterMenu}>
        <Scrollbars
          renderTrackHorizontal={(props) => (
            <div {...props} className="track-horizontal" />
          )}
        >
          {menu}
        </Scrollbars>
      </div>
    );
  };

  renderList = (dataList) => {
    return (
      <div
        class={style.dropDownlistWrapper}
        style={{ width: this.dropDownWrapper.offsetWidth - 2 }}
      >
        <div class={style.searchWrapper}>
          <div
            style={{
              width: this.dropDownWrapper.offsetWidth,
              textAlign: "center",
            }}
          >
            <input
              class={style.searchBar}
              style={{ width: this.dropDownWrapper.offsetWidth - 45 }}
              id="mysearch"
              type="search"
              placeholder={"Search"}
              onInput={(e) => {
                this.handleOnInputChange(e, this.state.dataList);
              }}
            />
          </div>
          {this.props.loading ? (
            <div class={style.preLoaderWrapper}>
              <PreLoader />
            </div>
          ) : dataList && dataList.length !== 0 ? (
            <div class={style.dropDownUl}>
              <Scrollbars
                renderTrackHorizontal={(props) => (
                  <div {...props} className="track-horizontal" />
                )}
              >
                <ul class={style.innerListWrapper}>
                  {this.generateInnerList(dataList)}
                </ul>
              </Scrollbars>
            </div>
          ) : (
            <div class={style.dropDownUl}>
              <div class={style.noResultWrapper}>
                <div>No Results</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  handleClickClose = () => {
    this.setState(
      {
        labelValue: "",
        inputval: "",
        selectedValue: "",
        closeBtnActive: false,
      },
      () => {
        this.props.handleClick("");
      }
    );
  };

  returnSdgIcon = (data) => {
    return (
      <img
        alt={`sdg No.${data.code}`}
        src={`/static/assets/icons/sdg-icons/sdg-small-${data.code}.png`}
        class={style.listItemIcon}
      />
    );
  };
  generateInnerList = (dataList) => {
    if (dataList && dataList.length)
      return dataList.map((data) => {
        return (
          <li
            tabIndex="0"
            class={
              this.props.isCountry
                ? `${style.countryListItem}`
                : `${style.listItem}`
            }
            onkeyup={(e) => this.handleEnterSelect(e, data)}
            onClick={() => {
              this.handleChange(data);
            }}
          >
            {this.props.listIcons && this.returnSdgIcon(data)}
            {this.props.isCountry ? (
              <img
                src={
                  this.props.baseURL +
                  "/static/assets/flag_icons/" +
                  data.level_3_code +
                  ".svg"
                }
                onError={(e) => {
                  e.target.src = "/static/assets/images/Empty.svg";
                }}
                class={style.flagIcon}
              />
            ) : null}
            <span class={style.listItemValue}>{data.label}</span>
          </li>
        );
      });
  };

  handleEnterSelect(event, data) {
    if (event.keyCode == "13") this.handleChange(data);
  }

  handleOnInputChange = (e, dataList) => {
    if (e.target.value === "") {
      this.setState({
        filteredList: this.state.dataList,
      });
    } else {
      let currentText = e.target.value.toUpperCase();
      let filteredData = dataList.filter((item) => {
        return item.label.toUpperCase().indexOf(currentText) !== -1;
      });
      this.setState({
        filteredList: filteredData,
      });
    }
  };

  // ------------ preserve false for droplists in Search Page ----- No Close Btn Needed------------>>>
  renderIcon = () => {
    if (this.state.closeBtnActive) {
      if (this.props.preserve && this.props.preserve == "false") {
        return (
          <div className={style.icon}>
            <i className="fas fa-chevron-down" />
          </div>
        );
      } else {
        return (
          <div className={style.icon}>
            <i
              className="fas fa-times"
              onClick={() => {
                this.handleClickClose();
              }}
            />
          </div>
        );
      }
    } else {
      return (
        <div className={style.icon}>
          <i className="fas fa-chevron-down" />
        </div>
      );
    }
  };

  render(
    {
      label,
      placeHolder,
      filterClass,
      dropDownClass,
      list,
      labelStyle,
      options,
    },
    state
  ) {
    placeHolder = placeHolder ? placeHolder : "select";
    const displayLabel =
      this.state.labelValue === "" ? placeHolder : this.state.labelValue;
    return (
      <div className={style.mainWrapper} ref={(node) => (this.filter = node)}>
        <span className={style.label}>{label}</span>
        <div
          className={style.valueIconWrapper}
          ref={(node) => (this.dropDownWrapper = node)}
          onClick={() => this.openSelect()}
        >
          <div>
            <span>
              {this.props.preserve && this.props.preserve === "false"
                ? placeHolder
                : displayLabel}
            </span>
          </div>
          <div>{this.renderIcon()}</div>
        </div>
        <div>
          {this.state.showSelect
            ? this.renderList(this.state.filteredList)
            : null}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/filter/index.js